type TeamPillProps = {
  name: string;
};

/**
 * Fully rounded team-membership pill. The Chip primitive only ships the
 * small-radius shape, so this reuses its neutral tokens with a pill radius.
 */
export function TeamPill({ name }: TeamPillProps) {
  return (
    <span className="inline-flex h-(--spacing-24) max-w-full items-center whitespace-nowrap rounded-full bg-chip-neutral-container px-(--spacing-10) font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-medium) text-chip-neutral-label">
      <span className="truncate">{name}</span>
    </span>
  );
}
